module.exports = __webpack_public_path__ + "img/ic_profile_wizard_skills.8c247fe4.svg";